
<div class="form-group row">
    <div class="col-sm-4">
        <input type="text" nbInput fullWidth placeholder="question">
        
    </div>
    <div class="col-sm-4">
        <nb-select (selectedChange)="onChangeType()" [(ngModel)]="type" matRipple>
            <nb-option *ngFor="let option of controlsList " matRipple [value]="option.key">{{option.value}}</nb-option>
        </nb-select>
    </div>
    <div class="col-sm-4">
        <nb-checkbox>Obligatoire</nb-checkbox>
    </div>

</div>
<div class="form-group row">
    <div class="col-sm-12">
        <textarea rows="5" nbInput fullWidth shape="round"  placeholder="description"></textarea>

    </div>
</div>